import React, {useState, useEffect} from 'react';
// import { Link } from 'react-router-dom';
//logo
// import LogoWhite from '../assets/img/logo-white.svg';
// import LogoDark from '../assets/img/logo-dark.svg';
import eng from '../assets/img/flag-eng.png';
import srb from '../assets/img/flag-srb.png';
import { Link } from 'react-router-dom';
import logo from '../assets/img/logoPA.png';
import { useTranslation } from 'react-i18next';

const Header = ({currentPage}) => {
  const [header, setHeader] = useState(false);
  // const [selectedLanguage, setSelectedLanguage] = useState('English');
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem('selectedLanguage') || 'English'
  );
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const [t, i18n] = useTranslation("global");

  useEffect(() => {
    window.addEventListener('scroll', () => {
      window.scrollY > 50 ? setHeader(true) : setHeader(false);
    });
  });

  // const handleLanguageChange = (language) => {
  //   setSelectedLanguage(language);
  //   i18n.changeLanguage(language);
  //   setIsDropdownOpen(false); 
  // };

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
    i18n.changeLanguage(language);
    localStorage.setItem('selectedLanguage', language);
    setIsDropdownOpen(false); 
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // const toggleMobileMenu = () => {
  //   setIsMobileMenuOpen(!isMobileMenuOpen);
  // };

  // const closeMobileMenu = () => {
  //   setIsMobileMenuOpen(false);
  // };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prevIsMobileMenuOpen) => !prevIsMobileMenuOpen);
  };
  
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };  

  const handleClick = (event, sectionId) => {
    event.preventDefault();
    const targetSection = document.getElementById(sectionId);
  if (targetSection) {
    // Smooth scroll to the target section
    targetSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
    closeMobileMenu();
  } else {
    console.error(`Element with id '${sectionId}' not found.`);
  }

    // document.getElementById(sectionId).scrollIntoView({
    //   behavior: 'smooth',
    //   block: 'start',
    // });
    // closeMobileMenu();
  };

  const handleScroll = () => {
    const testimonialsSection = document.getElementById('testimonials');
    const titleHeight = testimonialsSection.offsetTop;

    if (window.scrollY >= titleHeight) {
      testimonialsSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
  <header className={`${
    header ? 'bg-white py-6 shadow-lg' : 'bg-transparent py-8'
    } fixed z-50 w-full transition-all duration-500`}>
    <div className='container mx-auto flex flex-col items-center gap-y-6
    lg:flex-row lg:justify-between lg:gap-y-0'>
      {/* {logo} */}
      <div className={`${header ? 'text-primary' : 'text-white'} flex gap-x-4 font-tertiary tracking-[3px] text-[15px] items-center lg:gap-x-8`}>

      
      <a href='/' className='hover:text-accent transition'>
        {t("navBarT.lokacija")}
      </a>
      {/* <a href='/' className='w-[50px]'>
        <img src={logo}></img>
      </a> */}
      </div>

        {/* Mobile menu button */}
        <div className="lg:hidden">
          <button

            className={`
            ${isMobileMenuOpen ? 'text-black color-black' : (!header ? 'text-white color-white' : 'text-black color-black')} 
            focus:outline-none text-[17px] font-tertiary sm:text-[17px] transition-all duration-300
            `}
            onClick={toggleMobileMenu}
            style={{ position: 'relative', zIndex: 50 }}
          >
            {isMobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>

      {/* nav */}
      <nav className={`${header ? 'text-primary' : 'text-white'} flex gap-x-4 font-tertiary tracking-[3px] text-[15px] items-center uppercase lg:gap-x-8`}>
        {/* <a href='' className='hover:text-accent transition'>Home</a> */}
        <a href='/apartment/1' className='hover:text-accent transition hidden lg:inline-block'>Dream</a>
        <a href='/apartment/2' className='hover:text-accent transition hidden lg:inline-block'>DC Executive</a>
        <a href='#contact' className='hover:text-accent transition hidden lg:inline-block' onClick={(e) => handleClick(e, 'contact')}>{t("navBarT.contact")}</a>
        {currentPage === 'Home' ? (
        <a href='#testimonials' className='hover:text-accent transition hidden lg:inline-block' onClick={(e) => handleClick(e, 'testimonials')}>{t("navBarT.testimonials")}</a>
         ) : (
          <a href='#testimonial' className='hover:text-accent transition hidden lg:inline-block' onClick={(e) => handleClick(e, 'testimonial')}>{t("navBarT.testimonials")}</a>
          )}
         {currentPage === 'Home' ? (
            <a href='#locations' className='hover:text-accent transition hidden lg:inline-block' onClick={(e) => {handleClick(e, 'locations');  closeMobileMenu();}}>{t("navBarT.locations")}</a>
            ) : (
            <a href='#locationRoom' className='hover:text-accent transition hidden lg:inline-block' onClick={(e) => {handleClick(e, 'locationRoom');  closeMobileMenu();}}>{t("navBarT.locations")}</a>
            )}
        
        {/* Language dropdown hidden lg:block*/}
        <div className='relative hidden lg:block'>
        <button
            className={`${
              header ? 'text-black' : 'text-white'
            } hover:text-accent focus:outline-none text-[12px] font-tertiary sm:text-[15px] tracking-[1px]`}
            onClick={toggleDropdown}
          >
            Language: {selectedLanguage}
          </button>
          {isDropdownOpen && (
            // <div className='absolute mt-2 w-24 bg-white rounded-md shadow-lg'> w-full lg: w-auto
            <div className='absolute mt-2 left-1/2 items-center transform -translate-x-1/2 lg:right-3 w-full bg-white rounded-md shadow-lg flex justify-center border'>
              <ul className='py-1'>
                <li
                  className='cursor-pointer my-2 hover:bg-gray-200 text-black capitalize text-[12px] tracking-[1px] sm:text-[15px]'
                  onClick={() => handleLanguageChange('English')}
                >
                   <img
                    className='h-4 w-6 inline-block'
                    src={eng} // Replace with the correct path mr-2 px-4 py-2
                    alt='English Flag'
                  />
                  <span className='ml-2 text-md'>English</span>
                  {/* English */}
                </li>
                <li
                  className='cursor-pointer items-center mb-2 hover:bg-gray-200 text-black capitalize text-[12px] tracking-[1px] sm:text-[15px]'
                  onClick={() => handleLanguageChange('Srpski')}
                >
                  <img
                    className='h-6 w-6 inline-block items-center justify-center mx-auto'
                    src={srb} // Replace with the correct path mr-2
                    alt='Serbian Flag'
                  />
                  <span className='ml-2 text-md'>Srpski</span>
                  {/* Serbian */}
                </li>
              </ul>
            </div>
          )}
        </div>
      </nav>

      {/* Mobile menu */}
      {isMobileMenuOpen && (
        <div id="mobile-menu" 
        className="lg:hidden fixed inset-0 bg-white z-40"
        style={{
          transitionProperty: 'transform',
          transitionDuration: '2s',
          transitionTimingFunction: 'ease-in-out',
          transform: isMobileMenuOpen ? 'translateY(0)' : 'translateY(-100%)',
        }}
        >
      
            <div className="flex flex-col items-center justify-center h-screen tracking-[2px]">
              <a href='/' className='text-black text-lg py-2'>
                {t("navBarT.lokacija")}
              </a>
              <a
                href="/apartment/1"
                className="text-black text-lg py-2"
                onClick={closeMobileMenu}
              >
                Dream
              </a>
              <a
                href="/apartment/2"
                className="text-black text-lg py-2"
                onClick={closeMobileMenu}
              >
                DC.Executive
              </a>
              <a
                href="#contact"
                className="text-black text-lg py-2"
                onClick={(e) => {
                  handleClick(e, 'contact');
                  closeMobileMenu();
                }}
              >
                {t('navBarT.contact')}
              </a>
              {currentPage === 'Home' ? (
              <a href='#testimonials' className='text-black text-lg py-2' onClick={(e) => handleClick(e, 'testimonials')}>{t("navBarT.testimonials")}</a>
              ) : (
                <a href='#testimonial' className='text-black text-lg py-2' onClick={(e) => handleClick(e, 'testimonial')}>{t("navBarT.testimonials")}</a>
                )}
              {currentPage === 'Home' ? (
              <a href='#locations' className='text-black text-lg py-2' onClick={(e) => {handleClick(e, 'locations');  closeMobileMenu();}}>{t("navBarT.locations")}</a>
              ) : (
                <a href='#locationRoom' className='text-black text-lg py-2' onClick={(e) => {handleClick(e, 'locationRoom');  closeMobileMenu();}}>{t("navBarT.locations")}</a>
                )}

              {/* Language dropdown */}
              <div className="relative">
                <button
                  className="text-black text-lg py-2 focus:outline-none tracking-[2px]"
                  onClick={toggleDropdown}
                >
                  Language: {selectedLanguage}
                </button>
                {isDropdownOpen && (
                  <div className="absolute mt-2 left-1/2 transform -translate-x-1/2 w-full bg-white rounded-md shadow-lg flex justify-center border-black">
                    <ul className="py-1">
                      <li
                        className="cursor-pointer hover:bg-gray-200 mb-4 text-black capitalize text-[12px] tracking-[1px] sm:text-[15px]"
                        onClick={() => handleLanguageChange('English')}
                      >
                        <img
                          className="h-4 w-6 inline-block"
                          src={eng}
                          alt="English Flag"
                        />
                        <span className='ml-4 text-lg'>English</span>
                      </li>
                      <li
                        className="cursor-pointer items-center hover:bg-gray-200 text-black capitalize text-[12px] tracking-[1px] sm:text-[15px]"
                        onClick={() => handleLanguageChange('Srpski')}
                      >
                        <img
                          className="h-4 w-6 inline-block items-center"
                          src={srb}
                          alt="Serbian Flag"
                        />
                         <span className='ml-4 text-lg'>Srpski</span>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
            </div>
        )}

    </div>
    </header>
  );
};

export default Header;
